import React from 'react';
import { Utensils } from 'lucide-react';

const FoodLogCard = ({ data }) => {
  const items = data?.items || [];
  const totals = {
    kcal: data?.total_kcal || data?.totals?.kcal,
    protein_g: data?.total_protein_g || data?.totals?.protein_g,
    carb_g: data?.total_carb_g || data?.totals?.carb_g,
    fat_g: data?.total_fat_g || data?.totals?.fat_g,
  };
  return (
    <div className="bg-zinc-900/60 border border-zinc-800 rounded p-4 space-y-2" data-testid="card-food-log">
      <div className="flex items-center gap-2">
        <Utensils className="w-4 h-4 text-primary" />
        <span className="text-xs uppercase tracking-wider text-zinc-500">{data?.meal_type || 'meal'}</span>
      </div>
      <ul className="text-sm text-zinc-300 space-y-1">
        {items.map((it, i) => (
          <li key={i} className="flex justify-between gap-2">
            <span className="truncate">{it.name}{it.quantity ? ` · ${it.quantity}` : ''}</span>
            <span className="text-zinc-500 shrink-0">{Math.round(it.kcal || 0)} kcal</span>
          </li>
        ))}
      </ul>
      <div className="text-xs text-zinc-400 pt-2 border-t border-zinc-800">
        Total: <strong className="text-white">{Math.round(totals.kcal || 0)} kcal</strong>
        {' · '}P {Math.round(totals.protein_g || 0)}g · C {Math.round(totals.carb_g || 0)}g · F {Math.round(totals.fat_g || 0)}g
      </div>
    </div>
  );
};

export default FoodLogCard;
